import { Component } from '@angular/core';
import {DataProvider} from '../../providers/data/data';
import { ExhibitionPage } from '../../pages/exhibition/exhibition';
import { SpotPage } from '../../pages/spot/spot';
import { NavController , NavParams,IonicPage } from 'ionic-angular';
import { MuzeumPage } from '../../pages/muzeum/muzeum';

/**
 * Generated class for the MenuTabComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'menu-tab',
  templateUrl: 'menu-tab.html'
})
export class MenuTabComponent {
  lang:any;
  text: string;
  muzeum:any;
  MuzeumData:any;
  oneExe = false;
  constructor(public navCtrl: NavController, public navParams:NavParams,public _DataProvider:DataProvider) {
    console.log('Hello MenuTabComponent Component');
    this.text = 'Hello World';
    this.muzeum = this._DataProvider.getLocalStorage('muzeum');



  //  this.lang = this._DataProvider.getLocalStorage('lang');
   // this.MuzeumData = this._DataProvider.getMuzeumData(this.lang);
  }



  moveToPage(pagetoMove){
    console.log('pagetoMove',pagetoMove);
   if(pagetoMove=='exe'){

    this.navCtrl.setRoot(ExhibitionPage, {
      muzeum:this.muzeum,
    })
   }
   if(pagetoMove=='home'){
     
    this.navCtrl.setRoot(MuzeumPage, {
      muzeum:this.muzeum,
    })
   }




  }

}



// WEBPACK FOOTER //
// ./src/components/menu-tab/menu-tab.ts